export default "__VITE_ASSET__6GcAPD5S__"